import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLayoutEffect, useState } from 'react';
import { districtUrls } from '../../../../common/routes/urls/district';
import { useDeviceLocation } from '../../../../hooks/useDeviceLocation';
import { previewUrl } from '../../../../hooks/useTourPreview';
import { directionsUrl } from '../_tour-home';
import TourMap from './tour-map';
import TourMapCard from './tour-map-card';
// Room the map keeps between the selected pin and the card's top.
const CARD_GAP = 12;
// The tour's homes on a map, its count of them, and the selected home's card floated over its foot.
const TourMapStage = (props) => {
    const device = useDeviceLocation();
    const [cardHeight, setCardHeight] = useState(0);
    const { selected, stageRef, cardRef } = props;
    const visitedCount = props.homes.filter(h => props.visited.includes(h.id)).length;
    // The map keeps the selected pin above the card, however tall the card wraps.
    useLayoutEffect(() => {
        const card = cardRef.current;
        const stage = stageRef.current;
        if (selected === null || card === null || stage === null) {
            setCardHeight(0);
            return undefined;
        }
        // From the card's top to the map's foot: the card itself and the attribution beneath it.
        const measure = () => setCardHeight(stage.getBoundingClientRect().bottom - card.getBoundingClientRect().top + CARD_GAP);
        measure();
        const observer = new ResizeObserver(measure);
        observer.observe(card);
        return () => observer.disconnect();
    }, [selected, stageRef, cardRef]);
    return (_jsxs("div", { className: "tour-map-stage", ref: stageRef, children: [_jsx(TourMap, { homes: props.homes, shown: props.shown, visited: props.visited, selected: selected, obscuredBottom: cardHeight, locationAccess: device.access, location: device.location, onRequestLocation: device.request, onSelect: props.onSelect }), _jsxs("p", { className: "tour-map-badge", role: "status", children: [props.homes.length, " ", props.homes.length === 1 ? 'home' : 'homes', " \u00B7 ", visitedCount, " checked in"] }), selected !== null &&
                _jsx(TourMapCard, { cardRef: cardRef, home: selected, visited: props.visited.includes(selected.id), detailsHref: selected.propertyId === null
                        ? null
                        : previewUrl(districtUrls.toursHome.getURL({ id: props.tourId, stopId: selected.id }), props.previewing), directionsHref: directionsUrl(selected), onDismiss: () => props.onSelect(null) })] }));
};
export default TourMapStage;
